import React from "react";

function InputBox({ label, required, placeholder, type, icon, ...otherprops }) {
  return (
    <div className="flex flex-col w-full text-sm">
      <label
        className="block text-sm font-medium text-gray-700 mb-1"
        htmlFor={otherprops.id || otherprops.name}
      >
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      <div className="relative">
        {icon && (
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400">
            {icon}
          </div>
        )}
        <input
          className={`w-full px-3 py-2.5 border rounded-lg border-gray-200 
            focus:outline-none focus:ring-1 focus:ring-gray-300 
            disabled:text-gray-500 disabled:bg-gray-100 disabled:cursor-not-allowed
            ${icon ? "pl-10" : "pl-3"}`}
          type={type || "text"}
          placeholder={placeholder}
          required={required}
          {...otherprops}
        />
      </div>
    </div>
  );
}

export default InputBox;
